import React from 'react';
import { Box } from '@material-ui/core';
import moment from 'moment';
import { useSelector } from 'react-redux';

export const convertedLeadsColumn = [
  { Header: 'Lead Name', accessor: 'user.name' },
  // { Header: 'Phone No.', accessor: 'user.mobile' },
  {
    Header: 'Phone No.',
    accessor: 'mobile',
    Cell: (val) => {
      const lead = val.cell.row.original;
      const { moduleAccess } = useSelector(({ signInReducer }) => {
        return {
          moduleAccess: signInReducer.me
            ? signInReducer.me.data
              ? signInReducer.me.data.role
              : []
            : [],
        };
      });

      return (
        <>
          {moduleAccess.includes('bccSuperAdmin') ? (
            <Box display="flex">{lead.user.mobile}</Box>
          ) : null}
        </>
      );
    },
  },
  {
    Header: 'Email',
    accessor: 'email',
    Cell: (val) => {
      const lead = val.cell.row.original;
      const { moduleAccess } = useSelector(({ signInReducer }) => {
        return {
          moduleAccess: signInReducer.me
            ? signInReducer.me.data
              ? signInReducer.me.data.role
              : []
            : [],
        };
      });

      return (
        <>
          {moduleAccess.includes('bccSuperAdmin') ? (
            <Box display="flex">{lead.user.email}</Box>
          ) : null}
        </>
      );
    },
  },
  // { Header: 'Email', accessor: 'user.email' },
  { Header: 'Coupon Code', accessor: 'code' },
  { Header: 'Deal Size Potential', accessor: 'total' },
  {
    Header: 'Date',
    accessor: 'createdAt',
    Cell: (val) => {
      const lead = val.cell.row.original;
      let date = moment(lead && lead.createdAt).format('DD MMM YYYY');
      return (
        <>
          <Box display="flex">{date}</Box>
        </>
      );
    },
  },
];
